module.exports = __webpack_public_path__ + "img/272-5c5d00.png";